import React, { useState, useEffect } from 'react';
import { PDFDocument, rgb } from 'pdf-lib';
// import myPDF from "./report1.pdf";
import fontTHSarabunNew from '../../../../THSarabunNew.ttf';
import fontkit from '@pdf-lib/fontkit';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';
// import fs from 'fs';
import {
  formatDateTH,
  formatDateTHYYYY,
  formatDateTHDMMMYYYY,
} from '../../../../common/DateUtils';
import { toThaiDigits, formatNumber } from '../../../../common/NumberUtils';
import { date } from 'yup';

//from R3Frame.js

//ต้นฉบับจาก R1v2.js, 23-03-14
function R2() {
  const [pdfUrl, setPdfUrl] = useState('');
  const [param1, setParam1] = useState('');
  const [employee, setEmployee] = useState('');
  const [loading, setLoading] = useState(false);

  const { user: currentUser } = useSelector((state) => state.auth);

  const getEmployee = async (uid) => {
    console.log('--R2.js--getEmployee--1');
    setLoading(true);
    try {
      const { data } = await axios.get('/api/cis/employee/uid', {
        params: { id: uid },
      });

      console.log('--R2.js--getEmployee--2');

      // ดึง employee และ signature พร้อมกันใน Promise.all เพื่อลดเวลารอ
      const idCard = data?.forReportAdded2?.hrEmpNo;
      let signImgResult = '';
      if (idCard) {
        try {
          const { data: signData } = await axios.get(
            `/api/signupload/${idCard}`,
          );
          const rawSign = signData?.data;
          if (rawSign) {
            const buffer = new Buffer.from(rawSign, 'base64');
            signImgResult = `data:image/png;base64,${buffer.toString('base64')}`;
          }
        } catch (signErr) {
          console.log('signature error:', signErr?.response);
        }
      }

      // set employee พร้อม signImg ในครั้งเดียว ไม่ต้อง chain useEffect
      setEmployee({ ...data, signImg: signImgResult });
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  };

  var BASE64_MARKER = ';base64,';

  function convertDataURIToBinary(dataURI) {
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const uid = queryParams.get('id');
    console.log('--R1v2.js--uid--', uid);
    getEmployee(uid);
    // getDataFromAPI();
  }, []);

  useEffect(() => {
    const loadPdf = async () => {
      // const url = '/app/document3v3.pdf';
      const url = '/app/document2.pdf';
      const existingPdfBytes = await fetch(url).then((res) =>
        res.arrayBuffer(),
      );

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);

      const fontBytes = await fetch(fontTHSarabunNew).then((res) =>
        res.arrayBuffer(),
      );
      const myFont = await pdfDoc.embedFont(fontBytes, { subset: true });

      console.log('----R2v2---loadPdf----', employee?.emp?.firstName);

      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();

      //ชื่อ - นามสกุล
      if (!!employee?.emp?.firstName) {
        const title = employee.emp.title;
        let titleNm = '';
        if (title == 1) titleNm = 'นาย';
        if (title == 2) titleNm = 'นาง';
        if (title == 3) titleNm = 'นางสาว';
        const fName = employee.emp.firstName;
        const lName = employee.emp.lastName;
        const fullName = titleNm + fName + ' ' + lName;

        //ชื่อ-นามสกุล
        firstPage.drawText(`${fullName}`, {
          x: 145,
          y: 734,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //รหัสพนักงาน
      if (!!employee?.forReportAdded2?.empNo) {
        const newEmpNo = Array.from(employee?.forReportAdded2?.empNo).join(
          '    ',
        );
        firstPage.drawText(`${newEmpNo && toThaiDigits(newEmpNo)}`, {
          x: 214,
          y: 684,
          size: 14.8,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //วุฒิการศึกษา
      if (!!employee?.edu?.length > 0) {
        const isMain = employee.edu.find((ed) => ed.isMainEducation === true);

        if (isMain) {
          const branch =
            isMain.branchCodeSAP == '99999'
              ? isMain.branchOther
              : isMain.branchName;
          firstPage.drawText(branch, {
            x: 390,
            y: 712,
            size: 16,
            font: myFont,
            color: rgb(0, 0, 0.5),
          });

          firstPage.drawText(`${isMain.degreeName || ''} ${isMain.certificateName || ''}`, {
            x: 110,
            y: 712,
            size: 16,
            font: myFont,
            color: rgb(0, 0, 0.5),
          });

          // firstPage.drawText(isMain.certificateName, {
          //   x: 110 + isMain.degreeName.length + 10, // ปรับตำแหน่ง x ตามความยาวของ degreeName
          //   y: 712,
          //   size: 16,
          //   font: myFont,
          //   color: rgb(0, 0, 0.5),
          // });

          if (isMain?.honorsId != 1) {
            firstPage.drawText(
              isMain?.honorsName && toThaiDigits(isMain?.honorsName),
              {
                x: 390,
                y: 696,
                size: 14,
                font: myFont,
                color: rgb(0, 0, 0.5),
              },
            );
          }
        }
      }

      //ตำแหน่งงาน
      if (!!employee?.forReport) {
        firstPage.drawText(
          employee?.forReport?.hPos && toThaiDigits(employee?.forReport?.hPos),
          {
            x: 145,
            y: 629,
            size: 16,
            font: myFont,
            color: rgb(0, 0, 0.5),
          },
        );
      }

      if (employee?.emp?.idCard) {
        const newIdCard = Array.from(
          employee?.emp?.idCard && toThaiDigits(employee?.emp?.idCard),
        ).join('    ');
        firstPage.drawText(`${newIdCard}`, {
          x: 214,
          y: 656,
          size: 14.8,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //สังกัดแผนก
      // if (employee?.forReportAdded2?.empSection) {
      firstPage.drawText(
        (employee?.forReportAdded2?.empSection &&
          toThaiDigits(employee?.forReportAdded2?.empSection)) ||
          '-',
        {
          x: 130,
          y: 602,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        },
      );
      // }

      // กอง
      // if (employee?.emp?.empDepartment) {
      firstPage.drawText(
        (employee?.emp?.empDepartment &&
          toThaiDigits(employee?.emp?.empDepartment)) ||
          '-',
        {
          x: 362,
          y: 602,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        },
      );
      // }

      // ฝ่าย
      // if (employee?.forReportAdded2?.division) {
      firstPage.drawText(employee?.forReportAdded2?.division || '-', {
        x: 104,
        y: 574,
        size: 16,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });
      // }

      //รหัสสังกัด
      if (employee?.forReportAdded2?.orgCode) {
        firstPage.drawText(
          employee?.forReportAdded2?.orgCode &&
            toThaiDigits(employee?.forReportAdded2?.orgCode),
          {
            x: 390,
            y: 574,
            size: 16,
            font: myFont,
            color: rgb(0, 0, 0.5),
          },
        );
      }

      //อัตราเงินเดือน
      if (!!employee?.forReportAdded2?.salary) {
        const salary = `${parseInt(employee?.forReportAdded2?.salary)}`;

        //จัดให้อยู่กึ่งกลาง
        const start = 160;
        const end = 306;
        const space = end - start;
        const salaryLen = salary.length;
        const rest = space - salaryLen * 8; // ประมาณ 8px ต่อตัวอักษร
        const restHalf = Math.round(rest / 2);

        firstPage.drawText(salary && formatNumber(salary, true), {
          x: start + restHalf,
          y: 546,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //การใช้อัตรา
      if (!!employee?.forReportAdded2?.employmentRateName) {
        firstPage.drawText(`${employee?.forReportAdded2?.employmentRateName}`, {
          x: 135,
          y: 518,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //วันที่รายงานตัว
      if (!!employee?.forReportAdded2?.signDate) {
        const signDateTH = formatDateTHDMMMYYYY(
          employee?.forReportAdded2?.startWorkDate,
        );
        firstPage.drawText(signDateTH && toThaiDigits(signDateTH), {
          x: 196,
          y: 491,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //วันที่
      if (!!employee?.forReportAdded2?.startWorkDate) {
        const startWorkDateTH = formatDateTHDMMMYYYY(
          employee?.forReportAdded2?.startWorkDate,
        );
        const startWorkDateSplit = startWorkDateTH.split(' ');

        // ตรวจสอบว่ามีข้อมูลครบหรือไม่
        if (startWorkDateSplit.length < 3) {
          console.error(
            'Invalid date format from formatDateTH:',
            startWorkDateTH,
          );
          return; // หรือ continue ถ้าอยู่ใน loop
        }

        const cDate = startWorkDateSplit[0].startsWith('0')
          ? startWorkDateSplit[0].substring(1)
          : startWorkDateSplit[0];
        const cMonth = startWorkDateSplit[1];
        const cYear = startWorkDateSplit[2];

        //จัดให้อยู่กึ่งกลาง
        //1.กำหนดขอบเขต, 2.หาเนื้อที่, 3.เนื้อที่ลบตัวอักษรหารสอง, 4.และลบความยาวตัวอักษรด้วย,
        //5.ได้เนื้อที่ (แต่เป็นภาษาไทย ช่องไฟอาจไม่เท่าภาษาอังกฤษ เลยต้องร่นแกน x เผื่อไว้เองหน่อยนึง)
        const start = { date: 267, month: 366, year: 483 };
        const end = { date: 294, month: 462, year: 547 };
        const space = {
          date: end.date - start.date,
          month: end.month - start.month,
          year: end.year - start.year,
        };
        const dateLen = {
          date: cDate.length,
          month: cMonth.length,
          year: cYear.length,
        };
        const rest = {
          date: space.date,
          month: space.month - dateLen.month,
          year: space.year - dateLen.year,
        };
        const restHalf = {
          date: Math.round(rest.date / 2),
          month: Math.round(rest.month / 2),
          year: Math.round(rest.year / 2),
        };

        //วัน
        firstPage.drawText(`${cDate && toThaiDigits(cDate)}`, {
          x: 264 + restHalf.date - dateLen.date,
          y: 463,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //เดือน
        firstPage.drawText(`${cMonth}`, {
          x: 335 + restHalf.month - dateLen.month,
          y: 463,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //ปี
        firstPage.drawText(`${cYear && toThaiDigits(cYear)}`, {
          x: 479 + restHalf.year - dateLen.year,
          y: 463,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        const startDate = new Date(employee?.forReportAdded2?.startWorkDate);
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 90);
        const endWorkDateTH = formatDateTHDMMMYYYY(endDate);
        const endWorkDateSplit = endWorkDateTH.split(' ');
        const eDate = endWorkDateSplit[0].startsWith('0')
          ? endWorkDateSplit[0].substring(1)
          : endWorkDateSplit[0];
        const eMonth = endWorkDateSplit[1];
        const eYear = endWorkDateSplit[2];

        const estart = { date: 113, month: 181, year: 302 };
        const eend = { date: 143, month: 260, year: 367 };
        const espace = {
          date: eend.date - estart.date,
          month: eend.month - estart.month,
          year: eend.year - estart.year,
        };
        const eDateLen = {
          date: eDate.length,
          month: eMonth.length,
          year: eYear.length,
        };
        const erest = {
          date: espace.date,
          month: espace.month - eDateLen.month,
          year: espace.year - eDateLen.year,
        };
        const erestHalf = {
          date: Math.round(erest.date / 2),
          month: Math.round(erest.month / 2),
          year: Math.round(erest.year / 2),
        };

        //วัน
        firstPage.drawText(`${eDate && toThaiDigits(eDate)}`, {
          x: 105 + erestHalf.date - eDateLen.date,
          y: 438,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //เดือน
        firstPage.drawText(`${eMonth}`, {
          x: 175 + erestHalf.month - eDateLen.month,
          y: 438,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //ปี
        firstPage.drawText(`${eYear && toThaiDigits(eYear)}`, {
          x: 299 + erestHalf.year - eDateLen.year,
          y: 438,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //อนุมัติให้จ้าง - ชื่อผู้อนุมัติ (กึ่งกลาง)
      if (!!employee?.empDeputy?.PS_TPrefixName) {
        const headFullName = `${employee?.empDeputy?.PS_TPrefixName}${employee?.empDeputy?.PS_TName} ${employee?.empDeputy?.PS_TLastName}`;

        const start = 80;
        const end = 218;
        //จัดให้อยู่กึ่งกลาง

        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(headFullName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        firstPage.drawText(headFullName, {
          x: finalX,
          y: 208,
          size: fontSize,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //อนุมัติให้จ้าง - ตำแหน่ง (กึ่งกลาง)
      if (!!employee?.empDeputy?.ORG_TLongName) {
        const position = employee?.empDeputy?.ORG_TLongName;
        const fontSize = 14;

        firstPage.drawText(position, {
          x: 102,
          y: 188,
          size: fontSize,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เจ้าหน้าที่ HR - ชื่อผู้อนุมัติ (กึ่งกลาง)
      if (!!employee?.forReportAdded2?.hrEmpName) {
        const hrName = employee?.forReportAdded2?.hrEmpName;
        const start = 323;
        const end = 467;
        //จัดให้อยู่กึ่งกลาง

        const fontSize = 16;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(hrName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        firstPage.drawText(hrName, {
          x: finalX,
          y: 342,
          size: fontSize,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //วันที่
      if (!!employee?.forReportAdded2?.startWorkDate) {
        const signDateTH = formatDateTHDMMMYYYY(
          employee?.forReportAdded2?.startWorkDate,
        );
        const signDateSplit = signDateTH.split(' ');

        // ตรวจสอบว่ามีข้อมูลครบหรือไม่
        if (signDateSplit.length < 3) {
          console.error('Invalid date format from formatDateTH:', signDateTH);
          return; // หรือ continue ถ้าอยู่ใน loop
        }

        const cDate = signDateSplit[0].startsWith('0')
          ? signDateSplit[0].substring(1)
          : signDateSplit[0];
        const cMonth = signDateSplit[1];
        const cYear = signDateSplit[2];

        const fontSize = 16;

        const start = { date: 324, month: 370, year: 469 };
        const end = { date: 346, month: 445, year: 509 };

        // คำนวณความกว้างของข้อความจริง
        const textWidth = {
          date: myFont.widthOfTextAtSize(cDate, fontSize),
          month: myFont.widthOfTextAtSize(cMonth, fontSize),
          year: myFont.widthOfTextAtSize(cYear, fontSize),
        };
        const space = {
          date: end.date - start.date,
          month: end.month - start.month,
          year: end.year - start.year,
        };
        const center = {
          date: start?.date + space?.date / 2,
          month: start?.month + space?.month / 2,
          year: start?.year + space?.year / 2,
        };
        const final = {
          date: center?.date - textWidth?.date / 2,
          month: center?.month - textWidth?.month / 2,
          year: center?.year - textWidth?.year / 2,
        };

        //วัน
        firstPage.drawText(`${cDate && toThaiDigits(cDate)}`, {
          x: final?.date,
          y: 324,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //เดือน
        firstPage.drawText(`${cMonth}`, {
          x: final?.month,
          y: 324,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });

        //ปี
        firstPage.drawText(`${cYear && toThaiDigits(cYear)}`, {
          x: final?.year,
          y: 324,
          size: 16,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ลายเซ็นผู้สมัคร
      if (!!employee?.signImg) {
        function calculateImageSize(pngDims) {
          let imgWidth, imgHeight;

          // ตรวจสอบว่า ถ้าขนาดความกว้างของรูปภาพมากกว่าความสูง
          if (pngDims.width > pngDims.height) {
            // กำหนดความสูงให้ไม่เกิน 20px และปรับขนาดความกว้างตามสัดส่วนเดิม
            imgHeight = 30;
            imgWidth = (pngDims.width * imgHeight) / pngDims.height;
          } else {
            // กำหนดความกว้างให้ไม่เกิน 100px และปรับขนาดความสูงตามสัดส่วนเดิม
            imgWidth = 100;
            imgHeight = (pngDims.height * imgWidth) / pngDims.width;

            if (imgHeight > 30) {
              imgHeight = 30;
              imgWidth = (pngDims.width * imgHeight) / pngDims.height;
            }
          }

          return { width: imgWidth, height: imgHeight };
        }

        // ฟังก์ชันสำหรับวาดรูปภาพบน PDF โดยคงสัดส่วนเดิมไว้เมื่อความกว้างเกิน space
        async function drawImageOnPdf(image, firstPage) {
          // ปรับขนาดรูปภาพ
          const pngDims = image.scale(0.3);
          let { width: imgW, height: imgH } = calculateImageSize(pngDims);

          // พิกัดที่ต้องการวาดรูปภาพบน PDF
          const startX = 324;
          const startY = 361;
          const space = 472 - startX;

          // ตรวจสอบว่าความกว้างของรูปภาพเกินพื้นที่หรือไม่
          if (imgW > space) {
            // ปรับความกว้างให้เท่ากับพื้นที่และปรับความสูงตามสัดส่วนเดิม
            imgW = space - 20;
            imgH = (pngDims.height * imgW) / pngDims.width;
          }

          const rest = space - imgW;
          const restHalf = Math.round(rest / 2);

          // วาดรูปภาพบนหน้า PDF
          firstPage.drawImage(image, {
            x: startX + restHalf,
            y: startY,
            width: imgW,
            height: imgH,
          });
        }

        try {
          const image = await pdfDoc.embedPng(employee.signImg);
          drawImageOnPdf(image, firstPage);
        } catch (err) {
          console.log('err signature img', err);
        }
      }

      // Set the stroke width to 100px

      const pdfBytes = await pdfDoc.save();
      const pdfUrl = URL.createObjectURL(
        new Blob([pdfBytes], { type: 'application/pdf' }),
      );
      setPdfUrl(pdfUrl);

      // setPdfUrl("/app/document1.pdf");
      // setPdfUrl("https://pdf-lib.js.org/assets/with_update_sections.pdf");
    };
    loadPdf();
  }, [employee]);

  // https://dev.to/collegewap/fix-react-hook-useeffect-is-called-conditionally-25m5

  if (!currentUser) {
    return <Navigate to="/app/login" />;
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      {pdfUrl && (
        <iframe src={pdfUrl} width="100%" height="800px" title="PDF Viewer" />
      )}
    </div>
  );
}

export default R2;
